import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import '../../assets/styles/Fatwa.css';
import { CircularProgress } from '../../utils/materialUI';
import { Col, Row } from '../../utils/bootstrapUtils';
import { listHadith, setHadithIsLoadingTrue } from '../../actions/HadithActions';
import LOGO_SMALL from '../../assets/images/logo-50x51.png';
import { scrollToNavigation } from '../../utils/utils';

class Hadith extends Component {
    componentDidMount() {
        document.title = 'Public » Askimam';
        const hadithId = this.props.match.params.hadithId;
        this.props.setHadithIsLoadingTrue();
        this.props.listHadith(hadithId);
        scrollToNavigation();
    }

    renderHadith = hadith => (
        <div className="fatwa-holder">
            <div id="qa-header">
                <Row>
                    <Col md={3} className="qa-headers">
                        <span className="qa-header-heading">
                            Hadith: #
                        </span>
                        <span className="qa-header-content">
                            {hadith.id}
                        </span>
                    </Col>
                    <Col md={3} className="qa-headers">
                        <span className="qa-header-heading">
                            Date:
                        </span>
                        <span className="qa-header-content">
                            {
                                new Intl.DateTimeFormat('en-GB', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric',
                                }).format(new Date(hadith.answer.answer_modified))
                            }
                        </span>
                    </Col>
                    <Col md={6} />
                </Row>
            </div>
            <div className="question-panel">
                <div className="question-title">
                    <div className="panel-header">
                        <div className="image-holder">
                            <img className="logo-image" src={LOGO_SMALL} alt="AskImam" />
                        </div>
                        Title
                    </div>
                </div>

                <div className="qa-content-title">
                    <h4 dangerouslySetInnerHTML={{ __html: hadith.answer.question.title }} />
                </div>
            </div>

            <div className="question-panel">
                <div className="question-title">
                    <div className="panel-header">
                        <div className="image-holder">
                            <img className="logo-image" src={LOGO_SMALL} alt="AskImam" />
                        </div>
                        Question
                    </div>
                </div>
                <div className="question-content">
                    <div className="qa-content">
                        <h4
                            dangerouslySetInnerHTML={{ __html: hadith.answer.question.question }}
                        />
                    </div>
                </div>
            </div>

            <div className="question-answer">
                <div className="question-panel">
                    <div className="question-title">
                        <div className="panel-header">
                            <div className="image-holder">
                                <img className="logo-image" src={LOGO_SMALL} alt="AskImam" />
                            </div>
                            Hadith
                        </div>
                    </div>
                    <div className="question-content">
                        <div className="qa-content">
                            <h4
                                dangerouslySetInnerHTML={{ __html: hadith.answer.answer }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    render() {
        const { hadith } = this.props;
        return (
            <div className="fatwa">
                {
                    hadith.isLoading ?
                        (
                            <div className="loader">
                                <CircularProgress color="inherit" />
                            </div>
                        )
                        : !hadith.isLoading && hadith.hadith.id ?
                            this.renderHadith(hadith.hadith)
                            : (
                                <div className="result-not-found">
                                    No hadith found. Please refine your search criteria.
                                </div>
                            )
                }
            </div>
        );
    }
}

Hadith.propTypes = {
    match: PropTypes.object.isRequired,
    hadith: PropTypes.object.isRequired,
    setHadithIsLoadingTrue: PropTypes.func.isRequired,
    listHadith: PropTypes.func.isRequired,
};

const mapStateToProps = ({ listhadithReducer }) => ({
    hadith: listhadithReducer,
});

export default connect(mapStateToProps, {
    listHadith,
    setHadithIsLoadingTrue,
})(Hadith);
